import React, { useState } from "react";
import { IoMdArrowDropdown } from "react-icons/io";
import CustomLink from "../Link";

const MenuAccordion = ({ d }) => {
  const [toggle, setToggle] = useState(false);
  return (
    <>
      <li
        key={d.id}
        className={`mono_sidebar_menu_list ${d.dropdown ? "submenu" : ""}`}
        id={d.id}
        style={{ height: `${d.dropdown && toggle ? "auto" : "61px"}` }}
      >
        <CustomLink
          href={d.route}
          className="mono_nav_link"
          onClick={() => setToggle(d.dropdown ? !toggle : false)}
        >
          <div className="icon_text">
            {d.icon}
            <p>{d.menu}</p>
          </div>
          {d.dropdown && (
            <span>
              <IoMdArrowDropdown />
            </span>
          )}
        </CustomLink>
        <ul>
          {d.dropdown?.map((drop) => (
            <li key={drop.id}>
              <CustomLink href={drop.route} className="mono_nav_link dropdown">
                {drop.menu}
              </CustomLink>
            </li>
          ))}
        </ul>
      </li>
    </>
  );
};

export default MenuAccordion;
